import(/* webpackMode: "eager" */ "C:\\OSPanel6\\home\\tig\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\OSPanel6\\home\\tig\\src\\components\\common\\ContactForm.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\OSPanel6\\home\\tig\\src\\components\\common\\Footer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\OSPanel6\\home\\tig\\src\\components\\common\\Header.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\OSPanel6\\home\\tig\\src\\components\\common\\HeroSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\OSPanel6\\home\\tig\\src\\components\\ui\\Card.jsx");
;
import(/* webpackMode: "eager" */ "C:\\OSPanel6\\home\\tig\\src\\components\\ui\\Grade.jsx");
